module.exports = __webpack_public_path__ + "static/media/flecha_back1.3126c710.svg";